import { createFileRoute, Outlet } from '@tanstack/react-router';
import { ContractsPage } from '@/pages/contracts';
import { contractsSearchSchema } from '@/routes/-shared/contractsSearchSchema';

/**
 * La lista resta montata e dettaglio, creazione e modifica si aprono sopra
 * di lei sull'`Outlet`, come nella webapp: chiudere un pannello torna alla
 * lista con filtri e scorrimento di prima.
 */
export const Route = createFileRoute('/admin/_layout/contracts/_layout')({
  component: ContractsLayout,
  validateSearch: contractsSearchSchema,
});

function ContractsLayout() {
  return (
    <>
      <ContractsPage />
      <Outlet />
    </>
  );
}
